<template>
	<div class="wrapBox">
		<navheader current="3"></navheader>
		<div class="bannerBox">
			<div class="bannerCtx">
				<div class="banner-img-container">
					<img  src="../assets/images/tj/banner.png" class="imgsize"/>
				</div>
				<div class="text">常规体检</div>
			</div>
		</div>
		<div class="contentbox">
			<div class="contentItem">
				<div class="contentTitle">团队体检</div>
				<div>
					<div class="subtitle">简介：</div>
					<div class="ctx">主要集中于企业、团体体检的体检过程跟踪，根据客户职业特点、年龄层次、部分数据分析制定团检体检套餐，检后由总检医生统一解读报告。</div>
					<div class="btn" @click="showCode = true">去预约</div>
				</div>
				<img  src="../assets/images/tj/image21.png" class="contImg" />
			</div>	
			<div class="contentItem">
				<div class="contentTitle">个性化体检</div>
				<div>
					<div class="subtitle">简介：</div>
					<div class="ctx">检前由首席总检医师根据客人基本信息、健康状况、工作环境、饮食习惯、睡眠习惯、运动习惯及现有健康档案来规划体检内容，检后为其体检结果作深入分析，为您定制个性化健康方案和疾病预防的专业建议。</div>
					<div class="btn" @click="showCode = true">去预约</div>
				</div>
				<img  src="../assets/images/tj/image22.png" class="contImg1"/>
			</div>	
			<div class="contentItem">
				<div class="contentTitle">特殊单项体检 </div>
				<div>
					<div class="subtitle">简介：</div>
					<div class="ctx">根据客人情况选取针对性强的国内外先进医疗体检项目：阿尔茨海默症初筛、 脑健康检测肾癌、膀胱癌基因检测、粪便DNA检测、人体免疫细胞检测、肿瘤标志物检测等。</div>
					<div class="btn" @click="showCode = true">去预约</div>
				</div>
				<img  src="../assets/images/tj/image23.png" class="contImg2" />
			</div>	
		</div>	
		<footercommon></footercommon>
		<div v-if="showCode" class="codeBox" >
			<img src="../assets/images/code.jpg" alt="" style="width: 100%;height: 100%;object-fit: contain;">
			<div class="codeTitle" >请扫描二维码</div>
			<div class="closeBTN"  @click="showCode = false">
				<img src="../assets/images/close2.svg" alt="" style="width: 100%;height: 100%;object-fit: contain;">
			</div>
		</div>
	</div>
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	export default{
		components: { navheader,footercommon},
		props:['current'],
		data(){
			return{
				showCode:false
			}
		}
	}
</script>

<style lang="scss" scoped> 
.banner-img-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}

.imgsize{
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}

.bannerBox {
	.bannerCtx {
		position: relative;
		height: 22.9375rem;
		overflow: hidden;
	}
}

.contentbox{
		min-width: $commoneWidth;
		margin: 8.75rem 7.5rem;
		.contentItem{
			box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14);
			display: flex;
			position: relative;
			padding: 4.25rem 4.625rem;
			box-sizing: border-box;
			border-radius: 1.6875rem; 
			margin-bottom: 5rem;
			.contImg{
				width: 25.3125rem;
				height: 18.5rem;
			}
			.contImg1{
				width: 17.375rem;
				height: 18.5rem;
				top: 2.5rem;
			}
			.contImg2{
				width: 9rem;
				height: 17.875rem;
				top: 1.25rem;
				right: 4.375rem;
			}
			.contentTitle{
				position: absolute;
				width: 12.125rem;
				line-height: 4.375rem;
				top: -2.1875rem;
				left: -1.25rem;
				background-color:$baseColor;
				border-radius: 0px 1.125rem 1.125rem 1.125rem;
				color:#fff;
				text-align: center;
				font-size: 1.75rem;
			}
			.subtitle{
				color:$fintColor;
				font-size: 2rem;
				font-weight: 600;
				line-height: 2.25rem;
				margin-bottom: 1.5rem;
			}
			.ctx{
				font-size: 1.5rem;
				line-height: 2.25rem;
				color:$fintColor;
				margin-bottom: 2.5rem;
				width: 70%;
			}
			.btn{
				width: 12.125rem;
				line-height: 4.375rem;
				border-radius: 1.125rem;
				color:$baseColor;
				font-size: 1.75rem;
				border: 0.0625rem solid $baseColor;
				text-align: center;
			}
			img{
				position: absolute;
				top:0;
				right: 0;
			}
		}
	}
	.closeBTN{
		position: absolute;
		top: 1rem;
		right: 1rem;
		width: 2rem;
		height: 2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: transform 0.3s ease;
		
		&:hover {
			transform: rotate(180deg);
		}
	}
	.codeBox{
		box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14);
		background-color: #fff;
		padding:4rem;
		width: 20%; 
		height: auto;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		z-index: 9999;
		.codeTitle{
			font-size: 3rem;
			color: #333;
			text-align: center;
			margin-top: 2rem;
		}
	}
	@media screen and (max-width: 768px) {//手机版本
		.imgsize{
			width: 100%;
			height: 127px;
		}
		.contentbox{
			min-width: auto;
			max-width: 768px;
			margin: 10px auto;
			padding:0 10px;
			.contentItem{
				margin-top: 40px;
				padding:20px 20px 10px 20px;
				margin-bottom:0;
				position: relative;
				border-radius: 10px;
				.contImg{
					width: 168px;
					height:122px;
					top:10px;
				}
				.contImg1{
					width: 115px;
					height:112px;
				}
				.contImg2{
					width: 68px;
					height:120px;
					right: 20px;
				}
				.contentTitle{
					position: absolute;
					width: 94px;
					line-height: 40px;
					top:-20px;
					left:20px;
					font-size: 14px;
				}
				.subtitle{
					font-size: 14px;
					margin-bottom: 0;
				}
				.ctx{
					font-size: 12px;
					line-height: 20px;
					margin-bottom:10px;
				}
				.btn{
					width: 94px;
					line-height:30px;
					font-size:14px;
				}
			}
		}
		.bannerBox {
			.bannerCtx {
				height: 7.9375rem;
			}
		}
		.codeBox{
			width: 60%;
			padding:50px 50px 20px 50px;
			border-radius: 10px;
			.codeTitle{
				font-size: 20px;
				margin-top: 0px;
			}
		}
	}
	
</style>